export enum PointsInfoBannerType {
	JOIN_BASIC_AND_PLUS = 'JoinBasicAndPlus',
	PLUS = 'Plus',
	BASIC = 'Basic',
	VIP_BASIC = 'VipBasic',
	VIP_UPGRADE = 'VipUpgrade',
	VIP_PLUS = 'VipPlus',
	NO_CONTENT = 'NoContent',
	TO_LOGIN = 'ToLogin'
}
